// kapigen version 0.1.33
// eslint-disable
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { google } from "../google";
import { createClient } from "../../requestClientInternal";
import { PrivatedModerationStatusWireFormat3 as KaggleSdkAbusePrivatedModerationStatusWireFormat3 } from "../abuse";
import { SubscribeStateWireFormat3 as KaggleSdkNotificationsSubscribeStateWireFormat3 } from "../notifications";
import { TagWireFormat3 as KaggleSdkTagsTagWireFormat3 } from "../tags";
import { MedalWireFormat3 as KaggleSdkUsersMedalWireFormat3, UserAchievementTierWireFormat3 as KaggleSdkUsersUserAchievementTierWireFormat3, UserAvatarWireFormat3 as KaggleSdkUsersUserAvatarWireFormat3, UserWireFormat3 as KaggleSdkUsersUserWireFormat3 } from "../users";
export var BatchDeleteMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var BatchGetForumMessagesRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
var defaultBatchGetForumMessagesResponse = {
    messages: []
};
export var BatchGetForumMessagesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBatchGetForumMessagesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.messages) {
            message.messages = wireFormat.messages.map(function(i) {
                return CommentForumMessageWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
var defaultBlobCreationInfo = {
    token: "",
    createUrl: ""
};
export var BlobCreationInfoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultBlobCreationInfo, wireFormat);
        return message;
    }
};
export var BlobFileInfoWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.contentLength) {
            wireFormat.contentLength = message.contentLength.toString();
        }
        if (message === null || message === void 0 ? void 0 : message.lastModifiedDate) {
            wireFormat.lastModifiedDate = message.lastModifiedDate.toISOString();
        }
        return wireFormat;
    }
};
var defaultCommentAttachment = {
    id: 0,
    name: "",
    totalBytes: 0
};
export var CommentAttachmentWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCommentAttachment, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.totalBytes) {
            message.totalBytes = parseInt(wireFormat.totalBytes);
        }
        return message;
    }
};
var defaultCommentForumMessage = {
    id: 0,
    content: "",
    replies: [],
    attachments: [],
    canDelete: false,
    isUserAuthor: false,
    hasFlags: false,
    isDeleted: false,
    isAdminDeleted: false,
    isFlagged: false,
    isSpammed: false,
    currentKernelVersion: 0,
    isPinned: false,
    isAutoPrivated: false,
    isCollapsed: false,
    isPartial: false
};
export var CommentForumMessageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCommentForumMessage, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.postDate) {
            message.postDate = new Date(wireFormat.postDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.replies) {
            message.replies = wireFormat.replies.map(function(i) {
                return CommentForumMessageWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.attachments) {
            message.attachments = wireFormat.attachments.map(function(i) {
                return CommentAttachmentWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.parent) {
            message.parent = DiscussionItemLinkWireFormat3.fromJson(wireFormat.parent);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.author) {
            message.author = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.author);
        }
        if (wireFormat) {
            message.authorType = CommentAuthorTypeWireFormat3.fromJson(wireFormat.authorType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.votes) {
            message.votes = CommentVoteButtonWireFormat3.fromJson(wireFormat.votes);
        }
        if (wireFormat) {
            message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.feedbackTrackingData) {
            message.feedbackTrackingData = FeedbackTrackingDataWireFormat3.fromJson(wireFormat.feedbackTrackingData);
        }
        if (wireFormat) {
            message.moderationStatus = KaggleSdkAbusePrivatedModerationStatusWireFormat3.fromJson(wireFormat.moderationStatus);
        }
        return message;
    }
};
var defaultCommentVoteButton = {
    totalVotes: 0,
    totalUpvotes: 0,
    hasAlreadyVotedUp: false,
    hasAlreadyVotedDown: false,
    canUpvote: false,
    canDownvote: false
};
export var CommentVoteButtonWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCommentVoteButton, wireFormat);
        return message;
    }
};
export var CreateAttachmentRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.blobFileInfo) {
            wireFormat.blobFileInfo = BlobFileInfoWireFormat3.toJson(message.blobFileInfo);
        }
        return wireFormat;
    }
};
var defaultCreateAttachmentResponse = {};
export var CreateAttachmentResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateAttachmentResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.blobCreationInfo) {
            message.blobCreationInfo = BlobCreationInfoWireFormat3.fromJson(wireFormat.blobCreationInfo);
        }
        return message;
    }
};
export var CreateKernelMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.message) {
            wireFormat.message = MessageWireFormat3.toJson(message.message);
        }
        return wireFormat;
    }
};
var defaultCreateKernelMessageResponse = {
    messageId: 0,
    topicId: 0
};
export var CreateKernelMessageResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateKernelMessageResponse, wireFormat);
        return message;
    }
};
export var CreateReplyRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.message) {
            wireFormat.message = MessageWireFormat3.toJson(message.message);
        }
        return wireFormat;
    }
};
var defaultCreateReplyResponse = {
    messageId: 0
};
export var CreateReplyResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateReplyResponse, wireFormat);
        return message;
    }
};
export var CreateTopicRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.message) {
            wireFormat.message = MessageWireFormat3.toJson(message.message);
        }
        return wireFormat;
    }
};
var defaultCreateTopicResponse = {
    topicId: 0,
    messageId: 0
};
export var CreateTopicResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCreateTopicResponse, wireFormat);
        return message;
    }
};
export var DeleteAttachmentRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var DeleteTopicRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultDiscussion = {
    siteForums: []
};
export var DiscussionWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiscussion, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.currentUser) {
            message.currentUser = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.currentUser);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.siteForums) {
            message.siteForums = wireFormat.siteForums.map(function(i) {
                return ForumWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.topicSort = TopicListSortByWireFormat3.fromJson(wireFormat.topicSort);
        }
        return message;
    }
};
var defaultDiscussionForum = {
    siteForums: []
};
export var DiscussionForumWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiscussionForum, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.currentUser) {
            message.currentUser = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.currentUser);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.siteForums) {
            message.siteForums = wireFormat.siteForums.map(function(i) {
                return ForumWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.topicSort = TopicListSortByWireFormat3.fromJson(wireFormat.topicSort);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forum) {
            message.forum = ForumWireFormat3.fromJson(wireFormat.forum);
        }
        return message;
    }
};
var defaultDiscussionItemLink = {
    id: 0
};
export var DiscussionItemLinkWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiscussionItemLink, wireFormat);
        return message;
    }
};
var defaultDiscussionParamValues = {
    page: 0
};
export var DiscussionParamValuesWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiscussionParamValues, wireFormat);
        if (wireFormat) {
            message.group = TopicListGroupWireFormat3.fromJson(wireFormat.group);
        }
        if (wireFormat) {
            message.sortBy = TopicListSortByWireFormat3.fromJson(wireFormat.sortBy);
        }
        if (wireFormat) {
            message.category = TopicListCategoryWireFormat3.fromJson(wireFormat.category);
        }
        return message;
    }
};
var defaultDiscussionTopic = {
    siteForums: []
};
export var DiscussionTopicWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultDiscussionTopic, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.currentUser) {
            message.currentUser = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.currentUser);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.siteForums) {
            message.siteForums = wireFormat.siteForums.map(function(i) {
                return ForumWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.topicSort = TopicListSortByWireFormat3.fromJson(wireFormat.topicSort);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topic) {
            message.topic = ForumTopicWireFormat3.fromJson(wireFormat.topic);
        }
        return message;
    }
};
var defaultFeedbackTrackingData = {};
export var FeedbackTrackingDataWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultFeedbackTrackingData, wireFormat);
        if (wireFormat) {
            message.followUpStatus = FollowUpStatusWireFormat3.fromJson(wireFormat.followUpStatus);
        }
        return message;
    },
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.followUpStatus) {
            wireFormat.followUpStatus = FollowUpStatusWireFormat3.toJson(message.followUpStatus);
        }
        return wireFormat;
    }
};
var defaultForum = {
    allowAttachments: false,
    currentUserCanDownvote: false,
    isPrivate: false,
    hasUnreadTopics: false,
    recentAuthors: []
};
export var ForumWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultForum, wireFormat);
        if (wireFormat) {
            message.currentUserTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.currentUserTier);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastPostDate) {
            message.lastPostDate = new Date(wireFormat.lastPostDate);
        }
        if (wireFormat) {
            message.subscriptionState = KaggleSdkNotificationsSubscribeStateWireFormat3.fromJson(wireFormat.subscriptionState);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.recentAuthors) {
            message.recentAuthors = wireFormat.recentAuthors.map(function(i) {
                return KaggleSdkUsersUserAvatarWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastPostUser) {
            message.lastPostUser = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.lastPostUser);
        }
        return message;
    }
};
var defaultForumTopic = {
    allowAttachments: false,
    canDelete: false,
    comments: [],
    forumId: 0,
    forumName: "",
    id: 0,
    isDeleted: false,
    isDeletedLegacy: false,
    isFollowed: false,
    isLocked: false,
    isSpammed: false,
    isStickied: false,
    name: "",
    tags: [],
    totalVotes: 0,
    url: "",
    isBookmarked: false,
    isPrivate: false,
    isAutoPrivated: false
};
export var ForumTopicWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultForumTopic, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.comments) {
            message.comments = wireFormat.comments.map(function(i) {
                return CommentForumMessageWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.commentSort = CommentListSortByWireFormat3.fromJson(wireFormat.commentSort);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.firstMessage) {
            message.firstMessage = CommentForumMessageWireFormat3.fromJson(wireFormat.firstMessage);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.postDate) {
            message.postDate = new Date(wireFormat.postDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
            message.tags = wireFormat.tags.map(function(i) {
                return KaggleSdkTagsTagWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetForumMessagesInTopicRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.newUserSort) {
            wireFormat.newUserSort = CommentListSortByWireFormat3.toJson(message.newUserSort);
        }
        if (message === null || message === void 0 ? void 0 : message.filter) {
            wireFormat.filter = CommentListFilterWireFormat3.toJson(message.filter);
        }
        return wireFormat;
    }
};
var defaultGetForumMessagesInTopicResponse = {
    comments: []
};
export var GetForumMessagesInTopicResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetForumMessagesInTopicResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.comments) {
            message.comments = wireFormat.comments.map(function(i) {
                return CommentForumMessageWireFormat3.fromJson(i);
            });
        }
        if (wireFormat) {
            message.commentSort = CommentListSortByWireFormat3.fromJson(wireFormat.commentSort);
        }
        return message;
    }
};
export var GetForumMessageUpvotesRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetForumMessageUpvotesResponse = {
    upvoters: []
};
export var GetForumMessageUpvotesResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetForumMessageUpvotesResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.upvoters) {
            message.upvoters = wireFormat.upvoters.map(function(i) {
                return KaggleSdkUsersUserWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetForumRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
var defaultGetForumResponse = {};
export var GetForumResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetForumResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forum) {
            message.forum = ForumWireFormat3.fromJson(wireFormat.forum);
        }
        if (wireFormat) {
            message.topicSort = TopicListSortByWireFormat3.fromJson(wireFormat.topicSort);
        }
        return message;
    }
};
export var GetForumTopicByIdRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.readMask) {
            var _paths;
            wireFormat.readMask = ((_paths = message.readMask.paths) !== null && _paths !== void 0 ? _paths : []).join(",");
        }
        return wireFormat;
    }
};
var defaultGetForumTopicByIdResponse = {};
export var GetForumTopicByIdResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetForumTopicByIdResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forumTopic) {
            message.forumTopic = ForumTopicWireFormat3.fromJson(wireFormat.forumTopic);
        }
        return message;
    }
};
export var GetSiteForumsRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultGetSiteForumsResponse = {
    forums: []
};
export var GetSiteForumsResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetSiteForumsResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.forums) {
            message.forums = wireFormat.forums.map(function(i) {
                return ForumWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var GetTopicListByForumIdRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.category) {
            wireFormat.category = TopicListCategoryWireFormat3.toJson(message.category);
        }
        if (message === null || message === void 0 ? void 0 : message.group) {
            wireFormat.group = TopicListGroupWireFormat3.toJson(message.group);
        }
        if (message === null || message === void 0 ? void 0 : message.sortBy) {
            wireFormat.sortBy = TopicListSortByWireFormat3.toJson(message.sortBy);
        }
        if (message === null || message === void 0 ? void 0 : message.recency) {
            wireFormat.recency = TopicListRecencyWireFormat3.toJson(message.recency);
        }
        if (message === null || message === void 0 ? void 0 : message.myActivity) {
            wireFormat.myActivity = TopicListMyActivityWireFormat3.toJson(message.myActivity);
        }
        if (message === null || message === void 0 ? void 0 : message.author) {
            wireFormat.author = TopicListAuthorWireFormat3.toJson(message.author);
        }
        return wireFormat;
    }
};
var defaultGetTopicListResponse = {
    topics: [],
    count: 0
};
export var GetTopicListResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultGetTopicListResponse, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.topics) {
            message.topics = wireFormat.topics.map(function(i) {
                return TopicListItemWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.count) {
            message.count = parseInt(wireFormat.count);
        }
        return message;
    }
};
export var MessageWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var MessageVoteWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultNewTopicDto = {
    allowAttachments: false,
    forumId: 0,
    isPrivate: false
};
export var NewTopicDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultNewTopicDto, wireFormat);
        if (wireFormat) {
            message.authorTier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.authorTier);
        }
        if (wireFormat) {
            message.authorType = CommentAuthorTypeWireFormat3.fromJson(wireFormat.authorType);
        }
        return message;
    }
};
export var PinForumMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var ToggleFlagMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.reasonType) {
            wireFormat.reasonType = FlagReasonWireFormat3.toJson(message.reasonType);
        }
        return wireFormat;
    }
};
export var ToggleSpamMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
var defaultToggleSpamMessageResponse = {
    messageUrl: ""
};
export var ToggleSpamMessageResponseWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultToggleSpamMessageResponse, wireFormat);
        return message;
    }
};
var defaultTopicListDto = {
    canDownvote: false,
    showSubscribeButton: false,
    isSubscribed: false
};
export var TopicListDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTopicListDto, wireFormat);
        if (wireFormat) {
            message.subscription = KaggleSdkNotificationsSubscribeStateWireFormat3.fromJson(wireFormat.subscription);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.paramValues) {
            message.paramValues = DiscussionParamValuesWireFormat3.fromJson(wireFormat.paramValues);
        }
        return message;
    }
};
var defaultTopicListItem = {
    commentCount: 0,
    currentUserVote: 0,
    canUpvote: false,
    canDownvote: false,
    firstForumMessageId: 0,
    hasAdminResponse: false,
    id: 0,
    isSticky: false,
    lastCommenterName: "",
    lastCommenterUrl: "",
    tags: [],
    title: "",
    topicUrl: "",
    voteResumeUrl: "",
    votes: 0,
    isBookmarked: false
};
export var TopicListItemWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultTopicListItem, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.authorUser) {
            message.authorUser = KaggleSdkUsersUserAvatarWireFormat3.fromJson(wireFormat.authorUser);
        }
        if (wireFormat) {
            message.authorType = CommentAuthorTypeWireFormat3.fromJson(wireFormat.authorType);
        }
        if (wireFormat) {
            message.lastCommenterType = CommentAuthorTypeWireFormat3.fromJson(wireFormat.lastCommenterType);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastCommentPostDate) {
            message.lastCommentPostDate = new Date(wireFormat.lastCommentPostDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.lastViewDate) {
            message.lastViewDate = new Date(wireFormat.lastViewDate);
        }
        if (wireFormat) {
            message.medal = KaggleSdkUsersMedalWireFormat3.fromJson(wireFormat.medal);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.postDate) {
            message.postDate = new Date(wireFormat.postDate);
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.tags) {
            message.tags = wireFormat.tags.map(function(i) {
                return KaggleSdkTagsTagWireFormat3.fromJson(i);
            });
        }
        return message;
    }
};
export var UpdateFeedbackTrackingDataRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.feedbackTrackingData) {
            wireFormat.feedbackTrackingData = FeedbackTrackingDataWireFormat3.toJson(message.feedbackTrackingData);
        }
        return wireFormat;
    }
};
export var UpdateForumMessageSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.settingToToggle) {
            wireFormat.settingToToggle = ForumMessageSettingsWireFormat3.toJson(message.settingToToggle);
        }
        return wireFormat;
    }
};
export var UpdateForumSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.settingToToggle) {
            wireFormat.settingToToggle = ForumSettingsWireFormat3.toJson(message.settingToToggle);
        }
        return wireFormat;
    }
};
export var UpdateForumTopicSettingsRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.settingToToggle) {
            wireFormat.settingToToggle = ForumTopicSettingsWireFormat3.toJson(message.settingToToggle);
        }
        return wireFormat;
    }
};
export var UpdateManyFeedbackTrackingDataRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.feedbackTrackingData) {
            wireFormat.feedbackTrackingData = FeedbackTrackingDataWireFormat3.toJson(message.feedbackTrackingData);
        }
        return wireFormat;
    }
};
export var UpdateMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.message) {
            wireFormat.message = MessageWireFormat3.toJson(message.message);
        }
        return wireFormat;
    }
};
export var UpdateTopicRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.message) {
            wireFormat.message = MessageWireFormat3.toJson(message.message);
        }
        return wireFormat;
    }
};
export var VoteOnForumMessageRequestWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.forumMessageVote) {
            wireFormat.forumMessageVote = MessageVoteWireFormat3.toJson(message.forumMessageVote);
        }
        return wireFormat;
    }
};
export var CommentAuthorType;
(function(CommentAuthorType) {
    CommentAuthorType[// Default value of author type makes no claim about what type of author it is, and nothing special should be shown.
    "UNSPECIFIED"] = "unspecified";
    CommentAuthorType["HOST"] = "host";
    CommentAuthorType["DATASET_CREATOR"] = "datasetCreator";
    CommentAuthorType["TOPIC"] = "topic";
    CommentAuthorType["COMMENT"] = "comment";
    CommentAuthorType["ADMIN"] = "admin";
    CommentAuthorType["MODEL_CREATOR"] = "modelCreator";
})(CommentAuthorType || (CommentAuthorType = {}));
export var CommentAuthorTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "COMMENT_AUTHOR_TYPE_UNSPECIFIED":
            default:
                return CommentAuthorType.UNSPECIFIED;
            case "HOST":
                return CommentAuthorType.HOST;
            case "DATASET_CREATOR":
                return CommentAuthorType.DATASET_CREATOR;
            case "TOPIC":
                return CommentAuthorType.TOPIC;
            case "COMMENT":
                return CommentAuthorType.COMMENT;
            case "ADMIN":
                return CommentAuthorType.ADMIN;
            case "MODEL_CREATOR":
                return CommentAuthorType.MODEL_CREATOR;
        }
    }
};
export var CommentListFilter;
(function(CommentListFilter) {
    CommentListFilter["ALL"] = "all";
    CommentListFilter["KERNEL_VERSION"] = "kernelVersion";
})(CommentListFilter || (CommentListFilter = {}));
export var CommentListFilterWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CommentListFilter.ALL:
            case 0:
            default:
                return "ALL";
            case CommentListFilter.KERNEL_VERSION:
            case 1:
                return "KERNEL_VERSION";
        }
    }
};
export var CommentListSortBy;
(function(CommentListSortBy) {
    CommentListSortBy["UNSPECIFIED"] = "unspecified";
    CommentListSortBy["HOT"] = "hot";
    CommentListSortBy["NEW"] = "new";
    CommentListSortBy["OLD"] = "old";
    CommentListSortBy["TOP"] = "top";
})(CommentListSortBy || (CommentListSortBy = {}));
export var CommentListSortByWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "COMMENT_LIST_SORT_BY_UNSPECIFIED":
            default:
                return CommentListSortBy.UNSPECIFIED;
            case "COMMENT_LIST_SORT_BY_HOT":
                return CommentListSortBy.HOT;
            case "COMMENT_LIST_SORT_BY_NEW":
                return CommentListSortBy.NEW;
            case "COMMENT_LIST_SORT_BY_OLD":
                return CommentListSortBy.OLD;
            case "COMMENT_LIST_SORT_BY_TOP":
                return CommentListSortBy.TOP;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case CommentListSortBy.UNSPECIFIED:
            case 0:
            default:
                return "COMMENT_LIST_SORT_BY_UNSPECIFIED";
            case CommentListSortBy.HOT:
            case 1:
                return "COMMENT_LIST_SORT_BY_HOT";
            case CommentListSortBy.NEW:
            case 2:
                return "COMMENT_LIST_SORT_BY_NEW";
            case CommentListSortBy.OLD:
            case 3:
                return "COMMENT_LIST_SORT_BY_OLD";
            case CommentListSortBy.TOP:
            case 4:
                return "COMMENT_LIST_SORT_BY_TOP";
        }
    }
};
export var FlagReason;
(function(FlagReason) {
    FlagReason["UNSPECIFIED"] = "unspecified";
    FlagReason["OTHER"] = "other";
    FlagReason["SPAM"] = "spam";
    FlagReason["PLAGIARISM"] = "plagiarism";
    FlagReason["VOTE_MANIPULATION"] = "voteManipulation";
    FlagReason["ABUSIVE"] = "abusive";
    FlagReason["PRIVACY_VIOLATION"] = "privacyViolation";
    FlagReason["COPYRIGHT_VIOLATION"] = "copyrightViolation";
    FlagReason["UPVOTE_BEGGING"] = "upvoteBegging";
})(FlagReason || (FlagReason = {}));
export var FlagReasonWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case FlagReason.UNSPECIFIED:
            case 0:
            default:
                return "FLAG_REASON_UNSPECIFIED";
            case FlagReason.OTHER:
            case 1:
                return "FLAG_REASON_OTHER";
            case FlagReason.SPAM:
            case 2:
                return "FLAG_REASON_SPAM";
            case FlagReason.PLAGIARISM:
            case 3:
                return "FLAG_REASON_PLAGIARISM";
            case FlagReason.VOTE_MANIPULATION:
            case 4:
                return "FLAG_REASON_VOTE_MANIPULATION";
            case FlagReason.ABUSIVE:
            case 5:
                return "FLAG_REASON_ABUSIVE";
            case FlagReason.PRIVACY_VIOLATION:
            case 6:
                return "FLAG_REASON_PRIVACY_VIOLATION";
            case FlagReason.COPYRIGHT_VIOLATION:
            case 7:
                return "FLAG_REASON_COPYRIGHT_VIOLATION";
            case FlagReason.UPVOTE_BEGGING:
            case 8:
                return "FLAG_REASON_UPVOTE_BEGGING";
        }
    }
};
export var FollowUpStatus;
(function(FollowUpStatus) {
    FollowUpStatus["NONE"] = "none";
    FollowUpStatus["IN_PROGRESS"] = "inProgress";
    FollowUpStatus["DONE"] = "done";
})(FollowUpStatus || (FollowUpStatus = {}));
export var FollowUpStatusWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "NONE":
            default:
                return FollowUpStatus.NONE;
            case "IN_PROGRESS":
                return FollowUpStatus.IN_PROGRESS;
            case "DONE":
                return FollowUpStatus.DONE;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case FollowUpStatus.NONE:
            case 0:
            default:
                return "NONE";
            case FollowUpStatus.IN_PROGRESS:
            case 1:
                return "IN_PROGRESS";
            case FollowUpStatus.DONE:
            case 2:
                return "DONE";
        }
    }
};
export var ForumMessageSettings;
(function(ForumMessageSettings) {
    ForumMessageSettings["UNSPECIFIED"] = "unspecified";
    ForumMessageSettings["IS_PRIVATE"] = "isPrivate";
})(ForumMessageSettings || (ForumMessageSettings = {}));
export var ForumMessageSettingsWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ForumMessageSettings.UNSPECIFIED:
            case 0:
            default:
                return "FORUM_MESSAGE_SETTINGS_UNSPECIFIED";
            case ForumMessageSettings.IS_PRIVATE:
            case 1:
                return "IS_PRIVATE";
        }
    }
};
export var ForumSettings;
(function(ForumSettings) {
    ForumSettings["IS_READ_ONLY"] = "isReadOnly";
})(ForumSettings || (ForumSettings = {}));
export var ForumSettingsWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ForumSettings.IS_READ_ONLY:
            case 0:
            default:
                return "FORUM_SETTINGS_IS_READ_ONLY";
        }
    }
};
export var ForumTopicSettings;
(function(ForumTopicSettings) {
    ForumTopicSettings["IS_READ_ONLY"] = "isReadOnly";
    ForumTopicSettings["IS_STICKY"] = "isSticky";
})(ForumTopicSettings || (ForumTopicSettings = {}));
export var ForumTopicSettingsWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case ForumTopicSettings.IS_READ_ONLY:
            case 0:
            default:
                return "FORUM_TOPIC_SETTINGS_IS_READ_ONLY";
            case ForumTopicSettings.IS_STICKY:
            case 1:
                return "IS_STICKY";
        }
    }
};
export var TopicListAuthor;
(function(TopicListAuthor) {
    TopicListAuthor["UNSPECIFIED"] = "unspecified";
    TopicListAuthor["ADMIN"] = "admin";
})(TopicListAuthor || (TopicListAuthor = {}));
export var TopicListAuthorWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case TopicListAuthor.UNSPECIFIED:
            case 0:
            default:
                return "TOPIC_LIST_AUTHOR_UNSPECIFIED";
            case TopicListAuthor.ADMIN:
            case 1:
                return "TOPIC_LIST_AUTHOR_ADMIN";
        }
    }
};
export var TopicListCategory;
(function(TopicListCategory) {
    TopicListCategory["UNSPECIFIED"] = "unspecified";
    TopicListCategory["ALL"] = "all";
    TopicListCategory["FORUMS"] = "forums";
    TopicListCategory["COMPETITIONS"] = "competitions";
    TopicListCategory["DATASETS"] = "datasets";
    TopicListCategory["COMPETITION_WRITE_UPS"] = "competitionWriteUps";
    TopicListCategory["MODELS"] = "models";
})(TopicListCategory || (TopicListCategory = {}));
export var TopicListCategoryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "TOPIC_LIST_CATEGORY_UNSPECIFIED":
            default:
                return TopicListCategory.UNSPECIFIED;
            case "TOPIC_LIST_CATEGORY_ALL":
                return TopicListCategory.ALL;
            case "TOPIC_LIST_CATEGORY_FORUMS":
                return TopicListCategory.FORUMS;
            case "TOPIC_LIST_CATEGORY_COMPETITIONS":
                return TopicListCategory.COMPETITIONS;
            case "TOPIC_LIST_CATEGORY_DATASETS":
                return TopicListCategory.DATASETS;
            case "TOPIC_LIST_CATEGORY_COMPETITION_WRITE_UPS":
                return TopicListCategory.COMPETITION_WRITE_UPS;
            case "TOPIC_LIST_CATEGORY_MODELS":
                return TopicListCategory.MODELS;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case TopicListCategory.UNSPECIFIED:
            case 0:
            default:
                return "TOPIC_LIST_CATEGORY_UNSPECIFIED";
            case TopicListCategory.ALL:
            case 1:
                return "TOPIC_LIST_CATEGORY_ALL";
            case TopicListCategory.FORUMS:
            case 2:
                return "TOPIC_LIST_CATEGORY_FORUMS";
            case TopicListCategory.COMPETITIONS:
            case 3:
                return "TOPIC_LIST_CATEGORY_COMPETITIONS";
            case TopicListCategory.DATASETS:
            case 4:
                return "TOPIC_LIST_CATEGORY_DATASETS";
            case TopicListCategory.COMPETITION_WRITE_UPS:
            case 5:
                return "TOPIC_LIST_CATEGORY_COMPETITION_WRITE_UPS";
            case TopicListCategory.MODELS:
            case 6:
                return "TOPIC_LIST_CATEGORY_MODELS";
        }
    }
};
export var TopicListGroup;
(function(TopicListGroup) {
    TopicListGroup["UNSPECIFIED"] = "unspecified";
    TopicListGroup["ALL"] = "all";
    TopicListGroup["OWNED"] = "owned";
    TopicListGroup["UPVOTED"] = "upvoted";
    TopicListGroup["BOOKMARKED"] = "bookmarked";
    TopicListGroup["MY_ACTIVITY"] = "myActivity";
})(TopicListGroup || (TopicListGroup = {}));
export var TopicListGroupWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "TOPIC_LIST_GROUP_UNSPECIFIED":
            default:
                return TopicListGroup.UNSPECIFIED;
            case "TOPIC_LIST_GROUP_ALL":
                return TopicListGroup.ALL;
            case "TOPIC_LIST_GROUP_OWNED":
                return TopicListGroup.OWNED;
            case "TOPIC_LIST_GROUP_UPVOTED":
                return TopicListGroup.UPVOTED;
            case "TOPIC_LIST_GROUP_BOOKMARKED":
                return TopicListGroup.BOOKMARKED;
            case "TOPIC_LIST_GROUP_MY_ACTIVITY":
                return TopicListGroup.MY_ACTIVITY;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case TopicListGroup.UNSPECIFIED:
            case 0:
            default:
                return "TOPIC_LIST_GROUP_UNSPECIFIED";
            case TopicListGroup.ALL:
            case 1:
                return "TOPIC_LIST_GROUP_ALL";
            case TopicListGroup.OWNED:
            case 2:
                return "TOPIC_LIST_GROUP_OWNED";
            case TopicListGroup.UPVOTED:
            case 3:
                return "TOPIC_LIST_GROUP_UPVOTED";
            case TopicListGroup.BOOKMARKED:
            case 4:
                return "TOPIC_LIST_GROUP_BOOKMARKED";
            case TopicListGroup.MY_ACTIVITY:
            case 5:
                return "TOPIC_LIST_GROUP_MY_ACTIVITY";
        }
    }
};
export var TopicListMyActivity;
(function(TopicListMyActivity) {
    TopicListMyActivity["UNSPECIFIED"] = "unspecified";
    TopicListMyActivity["PUBLISHED"] = "published";
    TopicListMyActivity["COMMENTED"] = "commented";
    TopicListMyActivity["VIEWED"] = "viewed";
})(TopicListMyActivity || (TopicListMyActivity = {}));
export var TopicListMyActivityWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case TopicListMyActivity.UNSPECIFIED:
            case 0:
            default:
                return "TOPIC_LIST_MY_ACTIVITY_UNSPECIFIED";
            case TopicListMyActivity.PUBLISHED:
            case 1:
                return "TOPIC_LIST_MY_ACTIVITY_PUBLISHED";
            case TopicListMyActivity.COMMENTED:
            case 2:
                return "TOPIC_LIST_MY_ACTIVITY_COMMENTED";
            case TopicListMyActivity.VIEWED:
            case 3:
                return "TOPIC_LIST_MY_ACTIVITY_VIEWED";
        }
    }
};
export var TopicListRecency;
(function(TopicListRecency) {
    TopicListRecency["UNSPECIFIED"] = "unspecified";
    TopicListRecency["LAST_30_DAYS"] = "last30Days";
    TopicListRecency["LAST_7_DAYS"] = "last7Days";
    TopicListRecency["TODAY"] = "today";
})(TopicListRecency || (TopicListRecency = {}));
export var TopicListRecencyWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case TopicListRecency.UNSPECIFIED:
            case 0:
            default:
                return "TOPIC_LIST_RECENCY_UNSPECIFIED";
            case TopicListRecency.LAST_30_DAYS:
            case 1:
                return "TOPIC_LIST_RECENCY_LAST_30_DAYS";
            case TopicListRecency.LAST_7_DAYS:
            case 2:
                return "TOPIC_LIST_RECENCY_LAST_7_DAYS";
            case TopicListRecency.TODAY:
            case 3:
                return "TOPIC_LIST_RECENCY_TODAY";
        }
    }
};
export var TopicListSortBy;
(function(TopicListSortBy) {
    TopicListSortBy["UNSPECIFIED"] = "unspecified";
    TopicListSortBy["HOT"] = "hot";
    TopicListSortBy["TOP"] = "top";
    TopicListSortBy["NEW"] = "new";
    TopicListSortBy["RECENT"] = "recent";
    TopicListSortBy["ACTIVE"] = "active";
    TopicListSortBy["RELEVANCE"] = "relevance";
})(TopicListSortBy || (TopicListSortBy = {}));
export var TopicListSortByWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "TOPIC_LIST_SORT_BY_UNSPECIFIED":
            default:
                return TopicListSortBy.UNSPECIFIED;
            case "TOPIC_LIST_SORT_BY_HOT":
                return TopicListSortBy.HOT;
            case "TOPIC_LIST_SORT_BY_TOP":
                return TopicListSortBy.TOP;
            case "TOPIC_LIST_SORT_BY_NEW":
                return TopicListSortBy.NEW;
            case "TOPIC_LIST_SORT_BY_RECENT":
                return TopicListSortBy.RECENT;
            case "TOPIC_LIST_SORT_BY_ACTIVE":
                return TopicListSortBy.ACTIVE;
            case "TOPIC_LIST_SORT_BY_RELEVANCE":
                return TopicListSortBy.RELEVANCE;
        }
    },
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case TopicListSortBy.UNSPECIFIED:
            case 0:
            default:
                return "TOPIC_LIST_SORT_BY_UNSPECIFIED";
            case TopicListSortBy.HOT:
            case 1:
                return "TOPIC_LIST_SORT_BY_HOT";
            case TopicListSortBy.TOP:
            case 2:
                return "TOPIC_LIST_SORT_BY_TOP";
            case TopicListSortBy.NEW:
            case 3:
                return "TOPIC_LIST_SORT_BY_NEW";
            case TopicListSortBy.RECENT:
            case 4:
                return "TOPIC_LIST_SORT_BY_RECENT";
            case TopicListSortBy.ACTIVE:
            case 5:
                return "TOPIC_LIST_SORT_BY_ACTIVE";
            case TopicListSortBy.RELEVANCE:
            case 6:
                return "TOPIC_LIST_SORT_BY_RELEVANCE";
        }
    }
};
export var discussionsClient = {
    discussionsService: {
        batchDeleteMessage: createClient(BatchDeleteMessageRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/BatchDeleteMessage"),
        // Get a list of forum messages by ids.
        batchGetForumMessages: createClient(BatchGetForumMessagesRequestWireFormat3, BatchGetForumMessagesResponseWireFormat3, "discussions.DiscussionsService/BatchGetForumMessages"),
        // Creates a token & URL for use to upload a discussions attachment to blob storage.
        createAttachment: createClient(CreateAttachmentRequestWireFormat3, CreateAttachmentResponseWireFormat3, "discussions.DiscussionsService/CreateAttachment"),
        // Creates a comment on a kernel and returns the newly created message ID
        createKernelMessage: createClient(CreateKernelMessageRequestWireFormat3, CreateKernelMessageResponseWireFormat3, "discussions.DiscussionsService/CreateKernelMessage"),
        // Creates a reply to a message and returns the newly created message ID.
        createReply: createClient(CreateReplyRequestWireFormat3, CreateReplyResponseWireFormat3, "discussions.DiscussionsService/CreateReply"),
        // Creates a topic on a forum and returns the newly created topic ID and message ID.
        createTopic: createClient(CreateTopicRequestWireFormat3, CreateTopicResponseWireFormat3, "discussions.DiscussionsService/CreateTopic"),
        // Deletes an attachment from a discussion post and blob storage.
        deleteAttachment: createClient(DeleteAttachmentRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/DeleteAttachment"),
        deleteMessage: createClient(DeleteMessageRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/DeleteMessage"),
        deleteTopic: createClient(DeleteTopicRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/DeleteTopic"),
        getForum: createClient(GetForumRequestWireFormat3, GetForumResponseWireFormat3, "discussions.DiscussionsService/GetForum"),
        getForumMessagesInTopic: createClient(GetForumMessagesInTopicRequestWireFormat3, GetForumMessagesInTopicResponseWireFormat3, "discussions.DiscussionsService/GetForumMessagesInTopic"),
        getForumMessageUpvotes: createClient(GetForumMessageUpvotesRequestWireFormat3, GetForumMessageUpvotesResponseWireFormat3, "discussions.DiscussionsService/GetForumMessageUpvotes"),
        // TODO: See comment below on GetForumTopicsById
        getForumTopicById: createClient(GetForumTopicByIdRequestWireFormat3, GetForumTopicByIdResponseWireFormat3, "discussions.DiscussionsService/GetForumTopicById"),
        // TODO: Update this route to do query based authorization once that is implemented
        getSiteForums: createClient(GetSiteForumsRequestWireFormat3, GetSiteForumsResponseWireFormat3, "discussions.DiscussionsService/GetSiteForums"),
        // TODO: Update this route to do query based authorization once that is implemented
        getTopicListByForumId: createClient(GetTopicListByForumIdRequestWireFormat3, GetTopicListResponseWireFormat3, "discussions.DiscussionsService/GetTopicListByForumId"),
        pinForumMessage: createClient(PinForumMessageRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/PinForumMessage"),
        toggleFlagMessage: createClient(ToggleFlagMessageRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/ToggleFlagMessage"),
        toggleSpamMessage: createClient(ToggleSpamMessageRequestWireFormat3, ToggleSpamMessageResponseWireFormat3, "discussions.DiscussionsService/ToggleSpamMessage"),
        updateFeedbackTrackingData: createClient(UpdateFeedbackTrackingDataRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/UpdateFeedbackTrackingData"),
        // TODO: This will become ALLOW_LOGGED_IN_OR_ADMIN_IGNORING_FIELD_PERMISSIONS after ForumAuthorizer
        // is refactored to not incorporate `IsAdmin` in its expressions.
        updateForumMessageSettings: createClient(UpdateForumMessageSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/UpdateForumMessageSettings"),
        // TODO: This will become ALLOW_LOGGED_IN_OR_ADMIN_IGNORING_FIELD_PERMISSIONS after ForumAuthorizer
        // is refactored to not incorporate `IsAdmin` in its expressions.
        updateForumSettings: createClient(UpdateForumSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/UpdateForumSettings"),
        // TODO: This will become ALLOW_LOGGED_IN_OR_ADMIN_IGNORING_FIELD_PERMISSIONS after ForumAuthorizer
        // is refactored to not incorporate `IsAdmin` in its expressions.
        updateForumTopicSettings: createClient(UpdateForumTopicSettingsRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/UpdateForumTopicSettings"),
        updateManyFeedbackTrackingData: createClient(UpdateManyFeedbackTrackingDataRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/UpdateManyFeedbackTrackingData"),
        // Updates a message's content.
        updateMessage: createClient(UpdateMessageRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/UpdateMessage"),
        // Updates a topic's name and message content.
        updateTopic: createClient(UpdateTopicRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/UpdateTopic"),
        voteOnForumMessage: createClient(VoteOnForumMessageRequestWireFormat3, google.protobuf.EmptyWireFormat3, "discussions.DiscussionsService/VoteOnForumMessage")
    }
};
